import React, { memo } from 'react';

export const Pencil = memo(() => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3618 4.50868L14.1333 2.7418C14.4583 2.4168 15 2.4168 15.3083 2.7418L17.2583 4.6918C17.5833 5.00013 17.5833 5.5418 17.2583 5.8668C17.126 5.99917 15.5717 7.54937 15.4844 7.63644L13.8229 5.97577L12.3618 4.50868Z"
      fill="#464C5C"
    />
    <path d="M11.2276 5.74122L2.5 14.3751V17.5001H5.625L14.318 8.83145L11.2276 5.74122Z" fill="#464C5C" />
  </svg>
));
